import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import app from './init';

// Initialize services
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

// List of admin UIDs
const ADMIN_UIDS = [
  // Add your UID here after first login
  // Add your other admin's UID here
];

// Helper function to check if a user is an admin
const isUserAdmin = (uid) => ADMIN_UIDS.includes(uid);

export { auth, db, googleProvider, isUserAdmin }; 